import React from "react";
import { size } from "lodash";
import ElabPartBar from "../../components/ElabPartBar";

export const ElabPagination = ({
  currentSectionPage,
  totalSections,
  setCurrentSectionPage,
  data,
  currentPage,
  setCurrentPage,
  visited_pages,
  answers,
  pagination_color_decision,
  isAiGradingexercise,
  AisubmissionCounter,
  setAisubmissionCounter,
}) => {
  const ClickOnPart = (props) => {
    setCurrentPage(props);
    setCurrentSectionPage(parseInt(`${props}${1}`));
    if (props > currentPage) {
      if (isAiGradingexercise && data?.is_premium && AisubmissionCounter > 0) {
        setAisubmissionCounter(parseInt(`${AisubmissionCounter - 1}`));
      }
    } else if (props < currentPage) {
      if (AisubmissionCounter < data?.remaining_credits) {
        setAisubmissionCounter(parseInt(`${AisubmissionCounter + 1}`));
      }
    }
  };

  return (
    <div className="px-1">
      <div 
        className="grid gap-4"
        style={{ gridTemplateColumns: `repeat(${totalSections ? totalSections : 1}, minmax(0, 1fr))` }}
      >
        {data &&
          data.sections &&
          size(data.sections) > 1 &&
          data.sections.map((section, section_id) => {
            return (
              <div key={section_id}>
                <div
                  onClick={() => ClickOnPart(section.section_number)}
                  className="flex flex-col gap-2"
                  style={{ cursor: "pointer" }}
                >
                  <ElabPartBar
                    section_name={section.section_name}
                    currentPage={section.section_number}
                    pagination_color_decision={pagination_color_decision}
                    section_number={section.section_number}
                    standing_page={currentPage}
                    data={data}
                    answers={answers}
                  />
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};
